import { useTranslation } from 'react-i18next';
import { InfoBlock } from 'app/components';

const Insider = () => {
  const { t } = useTranslation(['common', 'my-profile']);

  const handleClickEdit = () => {};

  return (
    <div className="row mt-r-2-5">
      <div className="col-md-6">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="my-0">{t('my-profile:insider.title')}</h2>
              <button className="btn btn-secondary btn-sm" onClick={handleClickEdit}>
                {t('common:edit')} <i className="ms-2 fa-regular fa-gear" />
              </button>
            </div>
            <InfoBlock caption={t('my-profile:insider.name')} text="[Förnamn Efternamn]" className="border-bottom border-gray-300" />
          </div>
        </div>
      </div>
      <div className="col-md-6">
        <div className="card">
          <div className="card-body">
            <div className="d-flex justify-content-between align-items-center">
              <h2 className="my-0">{t('my-profile:insider-function.title')}</h2>
              <button className="btn btn-secondary btn-sm" onClick={handleClickEdit}>
                {t('common:edit')} <i className="ms-2 fa-regular fa-gear" />
              </button>
            </div>
            <InfoBlock caption={t('my-profile:insider.function')} text="[...]" className="border-bottom border-gray-300" />
          </div>
        </div>
      </div>
    </div>
  );
};

export default Insider;
